import axios from "axios";

// APLA APPLICATION START
export async function requestShowAPLAApplication(id) {
	return await axios.get(`${import.meta.env.VITE_API_URL}/admin/@apla/applications/${id}`);
}

export async function requestUpdateAPLAApplication(id, payload) {
	return await axios.put(
		`${import.meta.env.VITE_API_URL}/admin/@apla/applications/${id}/update`,
		payload,
		{ headers: { "Content-Type": "application/json" } }
	);
}

export async function requestGetAPLAApplicationDeployments(id) {
	return await axios.get(
		`${import.meta.env.VITE_API_URL}/admin/@apla/applications/${id}/deployments`
	);
}

export async function requestGetAPLAApplicationEnvironments(id) {
	return await axios.get(
		`${import.meta.env.VITE_API_URL}/admin/@apla/applications/${id}/environments`
	);
}

export async function requestCreateAPLAApplicationEnvironment(id, { key, value, isPreview }) {
	return await axios.post(
		`${import.meta.env.VITE_API_URL}/admin/@apla/applications/${id}/environments/create`,
		{ key, value, isPreview },
		{ headers: { "Content-Type": "application/json" } }
	);
}

export async function requestUpdateAPLAApplicationEnvironment(id, payload) {
	return await axios.put(
		`${import.meta.env.VITE_API_URL}/admin/@apla/applications/${id}/environments/update`,
		payload,
		{
			headers: {
				"Content-Type": "application/json",
			},
		}
	);
}

export async function requestDeleteAPLAApplicationEnvironment(id, envId) {
	return await axios.delete(
		`${import.meta.env.VITE_API_URL}/admin/@apla/applications/${id}/environments/${envId}/delete`
	);
}
// APLA APPLICATION END
